export var CourseType;
(function (CourseType) {
    CourseType[CourseType["TELEMATICS"] = 1] = "TELEMATICS";
    CourseType[CourseType["FACE_TO_FACE"] = 2] = "FACE_TO_FACE";
})(CourseType || (CourseType = {}));
